import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncYoutubeMusicToYoutubeMusic() {
    return (
        <GuidesPage
            seoData={seoContent.syncYoutubeMusicToYoutubeMusic}
            sections={<PairSyncGuideContent sourceKey="youtubeMusic" destKey="youtubeMusic" />}
        />
    );
}
